import { mergeClasses } from '@fluentui/react-components';
import HarmonyProvider from '@office-start/harmony-provider';
import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
import { AppHostedRouteComponent } from '../../routing/AppHostedRouteComponent';
import { useAppAIHubPoCStyles } from '../App/AppAIHubPoC.styles';
import { getContextParamsfromOfficeContext } from './Utils';
var MetaOsAppWrapperLazy = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "ai-hub-app-hosted" */ '@1js/ai-hub-metaos-wrapper');
}), 'MetaOsAppWrapper');
var AIHubAppHostedPage = function (_a) {
    var officeHomeAppRouteConfig = _a.officeHomeAppRouteConfig, componentContext = _a.componentContext;
    var appAIHubPoCStyles = useAppAIHubPoCStyles();
    var rootPath = componentContext.rootPath || '';
    var context = getContextParamsfromOfficeContext(componentContext);
    return (React.createElement(HarmonyProvider, null,
        React.createElement("div", { className: appAIHubPoCStyles.content, id: "officeHome", role: "application" },
            React.createElement("div", { className: mergeClasses(appAIHubPoCStyles.scrollContent, appAIHubPoCStyles.scrollContentNoShadow) },
                React.createElement(MetaOsAppWrapperLazy, { componentContext: context },
                    React.createElement(AppHostedRouteComponent, { officeHomeAppRouteConfig: officeHomeAppRouteConfig, rootPath: rootPath }))))));
};
export default AIHubAppHostedPage;
//# sourceMappingURL=AIHubAppHostedPage.js.map